// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Styled Components
import { StyledLink, StyledText } from "components/other/styles";

// #####################################################

const LocationsListingLink = ({ isBold }) => {
	const { t } = useTranslation(["pages"]);

	// #####################################################

	return (
		<StyledText>
			<StyledLink to={`/search/locations`} bold={Boolean(isBold)}>
				{t("pages:locations")}
			</StyledLink>
		</StyledText>
	);
};

// #####################################################

export default LocationsListingLink;

// #####################################################
